module.exports = __webpack_public_path__ + "assets/images/avatar_saude_coracao.c615aa0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/avatar_saude_coracao.png
// module id = 681
// module chunks = 1